module.exports = __webpack_public_path__ + "img/icon-dynamic.e1d52663.svg";